import React from 'react';
import { ActivityIndicator, Image, StyleSheet, View } from 'react-native';
import { Text } from 'react-native';
import Colors from '../constants/Colors';
import { useLocalization } from '../store/utils/useLocalization';

export const LoadingScreen = () => {
  const { translation } = useLocalization();
  return (
    <View style={styles.container}>
      <Image
        source={require('../assets/images/plentiful_logo_new.png')}
        resizeMode="contain"
        style={styles.logo}
      />
      <View style={styles.contentContainer}>
        <Text style={styles.text}>{translation.loading_message}</Text>
        <ActivityIndicator size="large" color={Colors.white} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.primaryColor,
    paddingHorizontal: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    width: 100,
    height: 100,
    // Ensure consistent sizing with splash screen
    aspectRatio: 1,
    // Position logo to match splash screen placement - center of screen
    position: 'absolute',
  },
  contentContainer: {
    position: 'absolute',
    bottom: '25%', // Position text/spinner in bottom quarter of screen
    alignItems: 'center',
    gap: 15,
  },
  text: {
    color: Colors.white,
    fontWeight: 'bold',
  },
});
